import { Crest } from "../../components/Crest";
import { RANKS } from "../../content/ranks";
import { rankFor } from "../../engine/rank";
import { profile } from "../../state/store";

/** All 12 ranks as a vertical timeline. Profile doesn't persist "date
    achieved" history, so this shows threshold + achieved/not rather than
    a dated timeline — see the note in the PR description for why. */
export function RankLadder() {
  const p = profile.value;
  const current = rankFor(p.clarity);
  const ceilLabel = Number.isFinite(current.clarityCeil) ? current.clarityCeil.toLocaleString() : "—";

  return (
    <div class="rank-ladder">
      {RANKS.slice()
        .reverse()
        .map((r) => {
          const achieved = p.clarity >= r.clarity;
          return (
            <div key={r.tier} class={"rank-ladder-row" + (achieved ? " rank-ladder-row-achieved" : "")}>
              <Crest status={rankFor(r.clarity)} seed={p.seed} size={22} />
              <span class="display rank-ladder-name">{r.name}</span>
              <span class="mono rank-ladder-clarity">{r.clarity.toLocaleString()} CLR</span>
            </div>
          );
        })}
      <div class="rank-ladder-current">
        <p class="label">Current: {current.name}</p>
        <div class="closest-plaque-bar">
          <div class="closest-plaque-fill" style={{ width: `${Math.min(1, Math.max(0, current.progress)) * 100}%` }} />
        </div>
        <p class="mono">
          {p.clarity.toLocaleString()} / {ceilLabel} CLR to next
        </p>
      </div>
    </div>
  );
}
